/**
 * Envia o eventos ao console facebook.
 * @param {string} event O tipo do evento.
 * @param {object} data Objeto com as informações e parâmetros a serem analisados.
 * @returns Função sem retorno, envia o evento com tipo e as informações ao analytics e ads.
 */
function fbEmmiter(event, data) {
  if (global.window && global.window.fbq && process.env.NODE_ENV === 'production') {
    window.fbq('track', event, data);
  }
}

/**
 * Envia um evento ao facebook com o valor e a moeda.
 * @param {object} cart Carrinho objeto.
 * @param {number} total Valor total do pedido.
 *
 */
export const fbEmmitCartOrPurchase = (event, lines, total = 0) =>
  fbEmmiter(event, {
    content_type: 'product',
    contents: lines.map((line) => ({ id: line.getIn(['product', 'sku']), quantity: line.getIn(['quantity']) })),
    currency: 'BRL',
    num_items: lines.length,
    value: total,
  });

export default fbEmmiter;
